<template>
    <div class="modal-overlay" @click.self="closeModal">
        <div class="modal-panel">
            <div class="close-btn-container">
                <img src="@/assets/images/icons/arrow_done.svg" alt="Close" class="close-btn" @click="closeModal" />
            </div>

            <div class="contact-form-section-wrapper">
                <p class="contact-form-block__title">Отправить заявку</p>
                <p class="contact-form-block__subtitle">
                    Заполните форму ниже или позвоните по телефону <br>
                    <a class="contact-form-block__subtitle-link" href="tel:+375173361999">+375 (17) 336-19-99</a>
                </p>

                <Form :is-modal="true" @submit-success="handleSuccess" key="modal-form"/>

            </div>
        </div>
    </div>
</template>

<script setup>
import { defineEmits } from 'vue';
import Form from '~/components/home/Form.vue';
import { useContentPages } from '@/stores/homeStores';

const emit = defineEmits(['close']);
const store = useContentPages();

const closeModal = () => {
    emit('close');
};

const handleSuccess = () => {
    store.setSuccessMessage('Ваша заявка успешно отправлена!');
    store.updateSuccessModal(true);
    closeModal();
};
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modal-panel {
    max-width: 650px;
    width: 95%;
    background: #fff;
    border-radius: 20px;
    padding: 32px;
    position: relative;
    max-height: 90vh;
    overflow-y: auto;
    box-sizing: border-box;
}

.close-btn-container {
    position: absolute;
    top: 15px;
    right: 15px;
}

.close-btn {
    width: 20px;
    height: 20px;
    cursor: pointer;
}

.contact-form {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.contact-form-section-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 28px;
}

.contact-form-block__title {
    font-weight: 600;
    font-size: 36px;
    line-height: 46px;
    text-align: center;
    margin: 0;
}

.contact-form-block__subtitle  {
    font-weight: 400;
    font-size: 18px;
    line-height: 26px;
    text-align: center;
    margin: 0;
}

.contact-form-block__subtitle-link  {
    font-weight: 700;
    font-size: 18px;
    line-height: 26px;
    text-align: center;
    color: #48538B;
}

.success-message {
    padding: 1rem;
    background-color: #d4edda;
    color: #155724;
    border: 1px solid #c3e6cb;
    border-radius: 4px;
    text-align: center;
}
</style>
